import {storeInstance} from '@aofl/store/dist/legacy';
import {deepAssign} from '@aofl/object-utils';
import {sdoNs} from '../../constants-enumerate';

const sdo = {
  namespace: 'sidePanels',
  mutations: {
    init() {
      return {
        left: {
          active: false,
          offCanvas: false
        },
        right: {
          active: false,
          offCanvas: false
        }
      };
    },
    setLeftActive(subState, active) {
      if (active === true) {
        subState = deepAssign(subState, 'right', {
          active: false
        });
      }
      return deepAssign(subState, 'left', {
        active
      });
    },
    setRightActive(subState, active) {
      if (active === true) {
        subState = deepAssign(subState, 'left', {
          active: false
        });
      }

      return deepAssign(subState, 'right', {
        active
      });
    },
    setLeftOffCanvas(subState, offCanvas) {
      return deepAssign(subState, 'left', {
        offCanvas
      });
    },
    setRightOffCanvas(subState, offCanvas) {
      return deepAssign(subState, 'right', {
        offCanvas
      });
    }
  },
  decorators: [
    (nextState) => { // $overlay
      const state = storeInstance.getState();
      if (typeof nextState[sdoNs.SIDE_PANELS].$overlay === 'undefined' ||
      nextState[sdoNs.SIDE_PANELS] !== state[sdoNs.SIDE_PANELS]) {
        const {left, right} = nextState[sdoNs.SIDE_PANELS];
        let $overlay = false;
        if (left.active || right.active) {
          $overlay = true;
        }

        nextState = deepAssign(nextState, sdoNs.SIDE_PANELS, {
          $overlay
        });
      }

      return nextState;
    }
  ]
};

storeInstance.addState(sdo);
